import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../services/AuthContext';
import { getRoleHomePath } from '../../utils/roleHomePath';

/** Redirection catch-all selon le rôle connecté. */
export default function RoleHomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={getRoleHomePath(user?.role)} replace />;
}
